import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MessageService } from '../../../../../../../shared/services/helpers/message-service/message.service';
import { ShootProofDataProvider } from '../../../../../../../shared/services/integrations/shootProof/shootProof.data.service';
import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SNModalService } from '@web-services/modal/snModal.service';
import { SelectExistingGalleryModal } from '@web-components/integrations/connect-galleries/modals/select-existing-gallery-modal/select-existing-gallery.modal';
import { CreateNewGalleryModal } from '@web-components/integrations/connect-galleries/modals/create-new-gallery-modal/create-new-gallery.modal';
import { PickTimeDataProvider } from '@services/integrations/pickTime/pickTime.data.service';
import { finalize, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { ShootProofGalleriesBrand } from '@models/models';

@Component({
	selector: 'add-gallery-modal',
	template: require('./add-gallery.modal.html'),
	styles: [require('./add-gallery.modal.scss')]
})
export class AddGalleryModal implements OnInit, OnDestroy {
	@Input('shootProofActions') shootProofActions;
	@Input('picTimeActions') picTimeActions;
	@Input('jobId') jobId;
	@Input('mainShootDate') mainShootDate;
	@Input('jobName') jobName;
	shootProofBrands = [];
	picTimeGalleries = [];
	disableShootProofModals = false;
	disablePicTimeModals = false;
	createGalleryModalRef: NgbModalRef;
	selectGalleryModalRef: NgbModalRef;

	private unsubscribe: Subject<void> = new Subject();

	constructor(
		private shootProofDataService: ShootProofDataProvider,
		private picTimeDataResponse: PickTimeDataProvider,
		private messageService: MessageService,
		private activeModal: NgbActiveModal,
		private modalService: SNModalService
	) {}

	ngOnInit(): void {
		if (this.shootProofActions.length) {
			this.getBrandsForGalleries();
		}
	}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	showSelectExistingShootProofGalleryModal() {
		this.activeModal.close();
		this.selectGalleryModalRef = this.modalService.openModal(
			SelectExistingGalleryModal,
			{
				windowClass: 'ng-bootstrap-modal-small'
			}
		);
		this.selectGalleryModalRef.componentInstance.shootProofBrands = this.shootProofBrands;
		this.selectGalleryModalRef.componentInstance.jobId = this.jobId;
	}

	showSelectExistingPicTimeGalleryModal() {
		this.activeModal.close();
		this.selectGalleryModalRef = this.modalService.openModal(
			SelectExistingGalleryModal,
			{
				windowClass: 'ng-bootstrap-modal-small pic-time-select-modal'
			}
		);
		this.selectGalleryModalRef.componentInstance.jobId = this.jobId;
	}

	showCreateNewShootProofGalleryModal() {
		this.activeModal.close();
		this.createGalleryModalRef = this.modalService.openModal(
			CreateNewGalleryModal,
			{
				windowClass: 'ng-bootstrap-modal-small'
			}
		);
		this.createGalleryModalRef.componentInstance.shootProofBrands = this.shootProofBrands;
		this.createGalleryModalRef.componentInstance.jobId = this.jobId;
		this.createGalleryModalRef.componentInstance.mainShootDate = this.mainShootDate;
		this.createGalleryModalRef.componentInstance.jobName = this.jobName;
	}

	showCreateNewPicTimeGalleryModal() {
		this.activeModal.close();
		this.createGalleryModalRef = this.modalService.openModal(
			CreateNewGalleryModal,
			{
				windowClass: 'ng-bootstrap-modal-small'
			}
		);
		this.createGalleryModalRef.componentInstance.jobId = this.jobId;
		this.createGalleryModalRef.componentInstance.mainShootDate = this.mainShootDate;
	}

	getBrandsForGalleries() {
		this.disableShootProofModals = true;
		this.shootProofDataService
			.getBrandsForGalleriesV1()
			.pipe(
				takeUntil(this.unsubscribe),
				finalize(() => (this.disableShootProofModals = false))
			)
			.subscribe(
				(data): ShootProofGalleriesBrand[] =>
					(this.shootProofBrands = data.data),
				error => this.messageService.showDefaultErrorMessage(error)
			);
	}

	onDismiss() {
		this.activeModal.close();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/integrations/connect-galleries/modals/add-gallery-modal/add-gallery.modal.ts